import React from 'react';
import { formatCurrency } from '../../utils/format';

/**
 * Per-therapist totals. Answers "who is carrying the load" at a glance, and
 * clicking a row filters the table to that therapist.
 */
export default function TherapistWorkload({
  therapists = [],
  loading,
  activeId,
  onSelect,
}) {
  // Bars are relative to the busiest therapist, not to an absolute scale.
  const max = Math.max(1, ...therapists.map((t) => t.total));

  return (
    <section className="mm-workload" aria-labelledby="workload-title">
      <h2 className="mm-workload__title" id="workload-title">
        Appointments by therapist
      </h2>

      {loading && (
        <div className="mm-workload__list">
          {Array.from({ length: 5 }, (_, i) => (
            <div className="mm-skeleton__bar" key={`wl-${i}`} />
          ))}
        </div>
      )}

      {!loading && (
        <ul className="mm-workload__list">
          {therapists.map((t) => {
            const isActive = String(activeId) === String(t.therapistId);
            return (
              <li key={t.therapistId}>
                <button
                  type="button"
                  className={`mm-workload__row ${
                    isActive ? 'mm-workload__row--active' : ''
                  }`}
                  onClick={() => onSelect(isActive ? '' : t.therapistId)}
                  aria-pressed={isActive}
                >
                  <img
                    className="mm-workload__photo"
                    src={t.image}
                    alt=""
                    loading="lazy"
                    width={34}
                    height={34}
                  />

                  <span className="mm-workload__body">
                    <span className="mm-workload__name">{t.name}</span>
                    <span className="mm-workload__meta">
                      {t.total} appointments &middot; {t.clients} clients &middot;{' '}
                      {formatCurrency(t.revenue, 'INR', { compact: true })}
                    </span>
                    <span className="mm-workload__bar" aria-hidden="true">
                      <span
                        className="mm-workload__bar-fill"
                        style={{ width: `${(t.total / max) * 100}%` }}
                      />
                    </span>
                  </span>

                  <span className="mm-workload__count">{t.total}</span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
